var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1725)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.79239 0.740845H7.58006V7.50114H0.79239V0.740845ZM17.7228 17.6986H19.4535V19.402H17.7228V17.6986ZM14.3966 17.6956H16.1274V19.3183H14.3966H14.3951H12.6659V15.9998H14.3419V14.3177H16.0468V10.9642H17.7775V12.6128H19.4262V14.3162H17.7775V16.0196H16.0726H16.0468H14.3966V17.6956ZM9.25759 14.2903H10.9336V12.5869H9.31234V10.8836H10.9336V9.18019H9.28496V10.8836H7.55268V9.18019H9.25607V4.12175H10.9868V9.17867H12.6628V10.882H14.3115V9.17867H16.0422V10.882H14.3966V12.5854H12.6659V15.939H10.9883V19.3199H9.25759V14.2903ZM17.6939 9.17867H19.4246V10.882H17.6939V9.17867ZM4.1733 9.17867H5.90406V10.882H4.1733V9.17867ZM0.79239 9.17867H2.52315V10.882H0.79239V9.17867ZM9.25759 0.740845H10.9883V2.44423H9.25759V0.740845ZM0.765015 12.6128H7.55268V19.3731H0.765015V12.6128ZM2.41364 14.2554H5.90406V17.7321H2.41364V14.2554ZM12.637 0.740845H19.4246V7.50114H12.637V0.740845ZM14.2871 2.38339H17.7775V5.86011H14.2871V2.38339ZM2.44102 2.38339H5.93143V5.86011H2.44102V2.38339Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6885,
    height: 18.6885,
    fill: "white",
    transform: "translate(0.765015 0.727173)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.37f90b7b5d653ce14aefda61bf2dac67.svg";
export { ForwardRef as ReactComponent };